import { render, staticRenderFns } from "./defalut.vue?vue&type=template&id=606646ca&scoped=true&"
import script from "./defalut.vue?vue&type=script&lang=js&"
export * from "./defalut.vue?vue&type=script&lang=js&"
import style0 from "./defalut.vue?vue&type=style&index=0&id=606646ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606646ca",
  null
  
)

export default component.exports